export default {
  body: {
    cmpt: {
      type: 'CActivity'
    }
  }
}
